module.exports = __webpack_public_path__ + "assets/061f51aeabd8560932f1349a8e6d32a7.png";